var map = {
	"./clorofila.jpg": "QuXm",
	"./colorscale_ori.jpg": "cPfJ",
	"./conOxigeno.jpg": "qOZY",
	"./icon_clorofila.svg": "68Mk",
	"./icon_con_ox.svg": "gm1+",
	"./icon_por_ox.svg": "xwPx",
	"./icon_salinidad.svg": "20IN",
	"./panel-icon-bathymetry.svg": "4C97",
	"./panel-icon-mosaicos.svg": "fKsG",
	"./panel-icon-params.svg": "3ygk",
	"./panel-icon-sonar.svg": "X6pc",
	"./porOxigeno.jpg": "jSKg",
	"./salinidad.jpg": "6nbg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KnWb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/params ^\.\/.*$
// module id = KnWb
// module chunks = 1